import { forwardRef, type JSX } from 'react';
import { Button, IIconProps, Tooltip } from '@logz-ui/styleguide';
import styled, { css } from 'styled-components';

interface IHeaderButtonProps {
  icon: IIconProps['icon'] | JSX.Element;
  active: boolean;
  subject?: string;
  label?: string;
  onClick?: () => void;
  loading?: boolean;
}

const StyledButton = styled(Button)<Partial<IHeaderButtonProps>>`
  cursor: pointer;

  color: ${({ theme }) => theme.colors.royalBlue[1000]};

  &:hover {
    color: ${({ theme }) => theme.colors.royalBlue[1000]};
  }
  ${({ active }) =>
    active &&
    css`
      background-color: ${({ theme }) => theme.colors.gray[100]};
    `}
`;

export const HeaderButton = forwardRef<HTMLDivElement, IHeaderButtonProps>(
  ({ active, icon, subject, label, onClick, loading }) => (
    <Tooltip title={label} disableEvents={!label} openDelayInMs={500}>
      <StyledButton
        loading={loading}
        onClick={onClick}
        round
        variant="tertiary"
        icon={icon}
        size="l"
        subject={subject}
        active={active}
      />
    </Tooltip>
  ),
);

HeaderButton.displayName = 'HeaderButton';
